export function InjectScriptSrc(srcUrl: string, onLoad?: Function) {
    const scriptTag = CreateScriptTag();
    scriptTag.src = srcUrl;

    if (onLoad) {
        scriptTag.onload = (evt) => { onLoad(evt); };
    }
}

var injects = [];

export function InjectCallbackScriptSrc(srcUrl: string, onLoad: Function) {

    var prevInject = getExistingInject(srcUrl);

    if (prevInject === null) {
        const scriptTag = CreateScriptTag();
        var fnName = "scrinj" + (Math.random() * 20000 + (+new Date())).toString().replace(/\./, "");
        window[fnName] = () => { onLoad(); };
        injects.push({
            url: srcUrl,
            name: fnName,
            isReady: false
        });
    
        scriptTag.src = srcUrl + (srcUrl.indexOf("?") !== -1 ? "&" : "?") + "callback=" + fnName;
    }
    else {
        onLoad();
    }
   
}


function getExistingInject(srcUrl: string) {
    for (let i = 0; i < injects.length; i++) {
        const inject = injects[i];
        if (inject.url === srcUrl)
            return inject;
    }

    return null;
}

function CreateScriptTag(): HTMLScriptElement {
    const script = <HTMLScriptElement>document.createElement("script");
    script.setAttribute("async", "");
    script.setAttribute("defer", "");

    const foundTags = document.getElementsByTagName("script");

    if (foundTags.length > 0) {
        const lastScriptTagFound = foundTags[foundTags.length - 1];
        lastScriptTagFound.parentElement.insertBefore(script, null);
    } else {
        document.body.insertBefore(script, null);
    }

    return script;
}
